import http from "../../http";

export default {
	addAccount: (data) => {
		return http.post('opservice/enterpriseadmin/save', data)
	}, //账号管理,添加账号
	deleteAccount: (data) => {
		return http.post('opservice/enterpriseadmin/delete', data)
	},//租户管理员删除企业管理员
    accountInfo: (params) => {
		return http.get('opservice/enterpriseadmin', params)
	},//get 租户管理员查看企业管理员详情
    validUsername: (params) => {
		return http.post('opservice/enterpriseadmin/validUsername', params)
	}, // 验证用户名是否存在

    getAccountPage: (params) => {
		return http.post('opservice/enterpriseadmin/paged', params)
	}, //分页获取账户列表
    getAccountPage1: (params) => {
		return http.post('opservice/enterpriseadmin/paged/by/orgid', params)
	},
    getAllAccount: (params) => {
		return http.post('opservice/enterpriseadmin/list', params)
	}, //获取该租户下的所有账户列表

    registAccount: (data) => {
		return http.post('opservice/regist/regist', data)
	},//企业用户注册
    existsAccount: (params) => {
		return http.post('opservice/regist/exists', params)
	},//检查用户名是否已存在



    assignOrgs: (data) => {
		return http.post('opservice/enterpriseadmin/assignOrgs', data)
	}, //租户管理员分派企业管理员权限
}
